import React, { useContext, useState } from 'react'
import PrimaryButton from '../buttons/PrimaryButton'
import ResponsiveModal from '../modal/ResponsiveModal';
import { useTranslation } from 'react-i18next';
import MenuImport from './MenuImport';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ExclusiveStarIcon from '../common/ExclusiveStarIcon';

type Props = {
    onStatusChange?: () => void;
}

const MenuImportButton = (props: Props) => {
    const [openModal, setOpenModal] = useState(false);
    const { t } = useTranslation();

    return (
        <>
            <PrimaryButton
                variant="outlined"
                onClick={() => setOpenModal(true)}
                startIcon={<CloudUploadIcon />}
                endIcon={
                    <div className="relative w-full h-full">
                        <ExclusiveStarIcon className="absolute -top-3 -right-5 text-white" />
                    </div>
                }
            >
                {t("menu.menu_import")}
            </PrimaryButton>
            <ResponsiveModal
                open={openModal}
                handleClose={() => setOpenModal(false)}
            >
                <div className="px-3 pb-1">
                    {openModal && <MenuImport
                        onStatusChange={props.onStatusChange}
                    />}
                </div>
            </ResponsiveModal>
        </>
    )
}

export default MenuImportButton